<template>
  <div id="three-bar-section">
    <div class="container">
      <div class="row">
        <div class="col-4 orange">
          <img
            :src="section.image_1.url"
            :alt="section.image_1.alt"
            loading="lazy"
          >
          <h1
            class="title"
            v-html="section.title_1"
          />
          <div
            class="content"
            v-html="section.content_1"
          />
        </div>
        <div class="col-4 white">
          <img
            :src="section.image_2.url"
            :alt="section.image_2.alt"
            loading="lazy"
          >
          <h1
            class="title"
            v-html="section.title_2"
          />
          <div
            class="content"
            v-html="section.content_2"
          />
        </div>
        <div class="col-4 black">
          <img
            :src="section.image_3.url"
            :alt="section.image_3.alt"
            loading="lazy"
          >
          <h1
            class="title"
            v-html="section.title_3"
          />
          <div
            class="content"
            v-html="section.content_3"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RysEmbedModal from '@/components/modals/EmbedModal.vue';
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'SplitImageSection',

  props: {
    section: { type: Object, required: true }
  },

  setup() {
    const modal = useModal();
    return { modal };
  },

  data() {
    return {
      showSlider: false,
      screenWidth: 0
    };
  },

  computed: {
    btnClass() {
      if (this.section.button_text) {
        if (this.section.style === 'fancy') {
          return 'black';
        }

        if (this.section.bg_color === 'white') {
          return 'ghost';
        }
      }

      return '';
    },

    imgXPos() {
      if (this.screenWidth >= 1170) {
        return this.section.img_x_pos;
      }
      return this.section.mob_img_x_pos;
    },

    imgYPos() {
      if (this.screenWidth >= 1170) {
        return this.section.img_y_pos;
      }
      return this.section.mob_img_y_pos;
    }
  },

  mounted() {
    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  },

  methods: {
    stripBlockTags,

    showEmbedModal(html) {
      this.modal(RysEmbedModal, this, { props: { embed: html } });
    },

    onLinkClick(e, section) {
      if (section.link_shows_video && section.video) {
        e.preventDefault();
        this.showEmbedModal(section.video);
      }
    },

    onWindowResize() {
      this.screenWidth = window.innerWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
@use 'sass:math';

#three-bar-section {
  padding: 25px 0;

  @media screen and (min-width: $breakpoint-lg) {
    padding: 25px 0;
  }

  .orange {
    background-color: #f96302;
    color: #ffffff;
    margin: 0;
    padding: 30px 30px 60px;
    line-height: 30px;

    .title {
      text-transform: uppercase;
      margin-top: 0;
    }

    .content {
      color: #ffffff;
      line-height: 28px;
    }
  }

  .white {
    color: #f96302;
    margin: 0;
    padding: 30px 30px 60px;
    line-height: 30px;

    .title {
      text-transform: uppercase;
      margin-top: 0;
    }

    .content {
      color: #f96302;
      line-height: 28px;
    }
  }

  .black {
    background-color: #040404;
    color: #ffffff;
    margin: 0;
    padding: 30px 30px 60px;
    line-height: 30px;

    .title {
      text-transform: uppercase;
      margin-top: 0;
    }

    .content {
      color: #ffffff;
      line-height: 28px;
    }
  }

  .button-holder {
    justify-content: center;
    margin-top: 20px;
  }

  h2::v-deep {
    font-size: 64px;
    line-height: 64px;
    color: $thd-black;
    margin: 0;
    text-transform: uppercase;

    strong {
      color: $thd-orange;
      font-weight: 700;
    }
  }

  .sub-text {
    margin-bottom: 40px;
    font-size: 20px;
  }

  img {
    width: 45%;
    margin: 0;
  }
}

.yel-class {
  display: block !important;
}
</style>
